import { useMutation } from 'react-query';

import { importToOpcXerFile as mutationFn } from 'api/endPoints/importToOpcXerFile';

export const useMutationImportToOpcXerFile = () => {
    return useMutation<unknown, QueryError, unknown>((params) => mutationFn(params));
};
